import { render } from "./User.vue?vue&type=template&id=aa7b6e22&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=aa7b6e22&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aa7b6e22"

export default script